import { render, staticRenderFns } from "./GridDoctor.vue?vue&type=template&id=5f5d4d58&scoped=true&"
import script from "./GridDoctor.vue?vue&type=script&lang=js&"
export * from "./GridDoctor.vue?vue&type=script&lang=js&"
import style0 from "./GridDoctor.vue?vue&type=style&index=0&id=5f5d4d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d4d58",
  null
  
)

export default component.exports